import { render, staticRenderFns } from "./CInputNumber.vue?vue&type=template&id=49fa5d3c&"
import script from "./CInputNumber.vue?vue&type=script&lang=js&"
export * from "./CInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports